import { Task } from "@src/domain/pascos/entities/task.entity";
import { TaskStatus } from "@src/domain/pascos/value_objects/task_status";
import type { TaskProps } from "@src/domain/pascos/value_objects/task_props";
import { UniqueEntityID } from "@src/domain/pascos/value_objects/unique_entity_Id";

export class TaskMap {
    static toDomain(raw: any): Task {
        // Validate that task_id exists in the response (API uses task_id, not id)
        if (!raw.task_id) {
            console.error("Task from API is missing 'task_id' field:", raw);
            throw new Error("Cannot create Task entity: 'task_id' field is required from API response");
        }

        // Validate and parse dates
        const createdAt = raw.created_at ? new Date(raw.created_at) : new Date();
        const updatedAt = raw.updated_at ? new Date(raw.updated_at) : new Date();

        // Check if dates are valid
        if (isNaN(createdAt.getTime())) {
            console.warn("Invalid created_at date:", raw.created_at, "Using current date");
        }
        if (isNaN(updatedAt.getTime())) {
            console.warn("Invalid updated_at date:", raw.updated_at, "Using current date");
        }

        const props: TaskProps = {
            status: raw.status as TaskStatus,
            pascoId: raw.pasco_id,
            errorMessage: raw.error_message,
            attemptCount: raw.attempt_count,
            createdAt: isNaN(createdAt.getTime()) ? new Date() : createdAt,
            updatedAt: isNaN(updatedAt.getTime()) ? new Date() : updatedAt,
        };

        return Task.create(props, new UniqueEntityID(raw.task_id));
    }

    static toPersistence(task: Task): any {
        return {
            task_id: task.taskId,
            status: task.status,
            pasco_id: task.pascoId,
            error_message: task.errorMessage,
            attempt_count: task.attemptCount,
            created_at: task.createdAt.toISOString(),
            updated_at: task.updatedAt.toISOString(),
        };
    }
}
